import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../styles/NeedGuidance.module.scss';
import { Button } from "react-bootstrap";
import { useRouter } from "next/router";
import { isFrappeOrJotFormClass } from "../utils/helpers";
import LazyReveal from "./LazyReveal";

interface Props {
  classname?: string;
  data :any;
  jotforms: any;
  externalLink:any;
}

const NewNeedGuidance: React.FC<Props>= ({data, jotforms, externalLink}) => {
  const router = useRouter();
  return (
    <>
      <LazyReveal id="need-guidance" className={styles.studentFooter}>
        <Container>
          <Row>
            <Col>
              <div className={styles.session}>
                <div>
                  <p  style={{ fontSize: '26px' }}>{data.sectionTitle}</p>
                </div>
                <div className={styles.anchor} >
                  <a href="/contact-us" className={styles.btTranparent}>Contact Us</a>
                   <Button onClick={() => {
                            !jotforms[0]?.jotformid && router.push(externalLink)
                        }}
                            className={`${styles.enquireBtn} ${jotforms[0]?.jotformid
                                ? ` ${isFrappeOrJotFormClass(jotforms[0]?.jotformid)}`
                                : ''
                                }`}
                        >
                     { data.button?.[0]?.label || 'Enquire Now' }
                    </Button>
                     {(jotforms.length > 1) && (<Button onClick={() => {
                            !jotforms[1]?.jotformid && router.push(data.url)
                        }}
                       className={`${styles.enquireBtn} ${jotforms[1]?.jotformid
                        ? ` ${isFrappeOrJotFormClass(jotforms[1]?.jotformid)}`
                        : ''
                        }`}>
                         { data.button?.[1]?.label || 'Enquire Now' }
                     </Button>)}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </LazyReveal>
    </>
  );
}

export default NewNeedGuidance;